import {
  signInWithPopup, signInWithEmailAndPassword, GoogleAuthProvider,
  signOut, signInAnonymously, onAuthStateChanged
} from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './init';

export async function signInWithGoogle() {
  const provider = new GoogleAuthProvider();
  return signInWithPopup(auth, provider);
}

export async function loginWithCredentials(email, password) {
  try {
    await signInWithEmailAndPassword(auth, email, password);
    return true;
  } catch (error) {
    console.error('Login mislukt:', error.message);
    return false;
  }
}

export async function adminSignOut() {
  await signOut(auth);
  await signInAnonymously(auth);
}

export async function signOutFirebase() {
  signOut(auth)
    .then(() => console.log('Signed out'))
    .catch((error) => console.log('Error signing out: ', error));
}

export function onAdminAuthStateChanged(callback) {
  return onAuthStateChanged(auth, callback);
}

// Reads the user's access from users/{uid} in Firestore.
// Returns { role, events } where:
//   role:   'owner' | 'editor' | 'viewer' | null (null = no access)
//   events: 'all' | string[]  (e.g. ['1900', '1724'])
// To grant access: open the `users` collection in the Firebase Console,
// find or create the document with the user's UID, and set the `role` field.
// Optionally set `events` to 'all' or an array of event IDs.
export async function getUserAccess(uid) {
  try {
    const snap = await getDoc(doc(db, 'users', uid));
    if (!snap.exists()) return { role: null, events: 'all' };
    const data = snap.data();
    return {
      role: data.role ?? null,
      events: data.events ?? 'all',
    };
  } catch (e) {
    console.error('getUserAccess failed — check Firestore rules for the admins collection:', e.message);
    return { role: null, events: 'all' };
  }
}
